import { useState } from "react";
import { IoIosArrowDown } from "react-icons/io";

const CollapsibleSection = ({ title, children, initialShowState = false, icon = null }) => {
    const [showInfo, setShowInfo] = useState(initialShowState);
    return (
        <div
            style={{
                border: "1px solid #dbdbdb",
                borderRadius: "10px",
                padding: "10px 15px"
            }}
        >
            <div
                className="d-flex align-items-center justify-content-between"
                style={{ cursor: "pointer" }}
                onClick={() => { setShowInfo(!showInfo); }}
            >
                <div className="d-flex align-items-center">
                    {icon && (
                        <div
                            style={{
                                marginRight: "8px"
                            }}
                        >
                            {icon}
                        </div>
                    )}
                    <p className="fw-bold">{title}</p>
                </div>

                <IoIosArrowDown
                    fontSize={22}
                    style={{
                        transition: "transform 0.4s ease",
                        transform: showInfo ? "rotate(-180deg)" : "rotate(0deg)",
                        color: "#1565c0",
                    }}
                />
            </div>

            {showInfo && children && (
                <>
                    <hr style={{ margin: "8px 0", borderColor: "#90caf9" }} />
                    {children}
                </>
            )}
        </div>
    );
}

export default CollapsibleSection;